import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.46103 7.13367C7.52301 7.07119 7.59674 7.02159 7.67798 6.98774C7.75922 6.9539 7.84636 6.93647 7.93437 6.93647C8.02238 6.93647 8.10951 6.9539 8.19075 6.98774C8.27199 7.02159 8.34573 7.07119 8.4077 7.13367L11.461 10.1937C11.523 10.2562 11.5967 10.3058 11.678 10.3396C11.7592 10.3734 11.8464 10.3909 11.9344 10.3909C12.0224 10.3909 12.1095 10.3734 12.1908 10.3396C12.272 10.3058 12.3457 10.2562 12.4077 10.1937C12.5319 10.0688 12.6016 9.8998 12.6016 9.72367C12.6016 9.54755 12.5319 9.37858 12.4077 9.25367L9.3477 6.19367C8.9727 5.81914 8.46437 5.60876 7.93437 5.60876C7.40437 5.60876 6.89604 5.81914 6.52103 6.19367L3.46103 9.25367C3.33787 9.37785 3.26844 9.54544 3.2677 9.72034C3.26719 9.80808 3.28401 9.89505 3.31719 9.97628C3.35036 10.0575 3.39925 10.1314 3.46103 10.1937C3.52301 10.2562 3.59674 10.3058 3.67798 10.3396C3.75922 10.3734 3.84636 10.3909 3.93437 10.3909C4.02237 10.3909 4.10951 10.3734 4.19075 10.3396C4.27199 10.3058 4.34572 10.2562 4.4077 10.1937L7.46103 7.13367Z",
		fill: "#333333"
	})
});
export default SvgUpArrow;
